var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalEditionRol",
      attrs: {
        title: "Editar Permisos del Rol: " + _vm.rol.nombre,
        "hide-footer": "",
        centered: "",
        size: "lg"
      }
    },
    [
      _c("b-overlay", { attrs: { show: _vm.isSaving || _vm.isLoading } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filter,
                  expression: "filter"
                }
              ],
              staticClass: "form-control",
              attrs: { placeholder: "Buscar..." },
              domProps: { value: _vm.filter },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filter = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12 scroll-area" }, [
            _c(
              "ul",
              { staticClass: "list-group mt-5" },
              _vm._l(_vm.filteredPermissions, function(permission) {
                return _c(
                  "li",
                  { key: permission.codigo, staticClass: "list-group-item" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-md-10" }, [
                        _c(
                          "h6",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: permission.descripcion,
                                expression: "permission.descripcion"
                              }
                            ]
                          },
                          [_vm._v(" " + _vm._s(permission.nombre) + " ")]
                        ),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(permission.codigo) +
                              " : " +
                              _vm._s(permission.accion) +
                              " "
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-md-2" },
                        [
                          _c("b-form-checkbox", {
                            attrs: {
                              switch: "",
                              size: "lg",
                              value: "si",
                              "unchecked-value": "no"
                            },
                            model: {
                              value: permission.asignado,
                              callback: function($$v) {
                                _vm.$set(permission, "asignado", $$v)
                              },
                              expression: "permission.asignado"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                on: { click: _vm.savePermissionRol }
              },
              [_vm._v(" Guardar ")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }